module.exports = __webpack_public_path__ + "static/media/ic_audit.340d05c4.svg";